import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { IdentityService } from '../authentication/identity.service';
import { NotificationsService } from '../notifications/notifications.service';
import {
  RegisterMercadopagoVendorCommand,
  IRegisterMercadopagoVendorParameters
} from './command/registerMercadopagoVendor.command';
import {
  DeleteMercadopagoVendorCommand,
  IDeleteMercadopagoVendorParameters
} from './command/deleteMercadopagoVendor.command';
import {
  RegisterMailchimpVendorCommand,
  IRegisterMailchimpVendorParameters
} from './command/registerMailchimpVendor.command';
import {
  DeleteMailchimpVendorCommand,
  IDeleteMailchimpVendorParameters
} from './command/deleteMailchimpVendor.command';
import {
  RegisterStripeVendorCommand,
  IRegisterStripeVendorParameters
} from './command/registerStripeVendor.command';
import {
  DeleteStripeVendorCommand,
  IDeleteStripeVendorParameters
} from './command/deleteStripeVendor.command';

@Injectable()
export class VendorService {
  private titleMessage = 'toast.integrations.title';

  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService,
    private _notificationsService: NotificationsService
  ) {}

  public setMercadopagoCode(code: string): Observable<boolean> {
    const command = new RegisterMercadopagoVendorCommand();
    command.setParameters(<IRegisterMercadopagoVendorParameters>{
      userId: this._identityService.subUserId,
      code
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public deleteMercadopagoVendor(appId: number): Observable<boolean> {
    const command = new DeleteMercadopagoVendorCommand();
    command.setParameters(<IDeleteMercadopagoVendorParameters>{
      userId: this._identityService.subUserId,
      appId
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public setMailchimpCode(code: string): Observable<boolean> {
    const command = new RegisterMailchimpVendorCommand();
    command.setParameters(<IRegisterMailchimpVendorParameters>{
      userId: this._identityService.subUserId,
      code
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public deleteMailchimpVendor(): Observable<boolean> {
    const command = new DeleteMailchimpVendorCommand();
    command.setParameters(<IDeleteMailchimpVendorParameters>{
      userId: this._identityService.subUserId
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public setStripeCode(code: string): Observable<boolean> {
    const command = new RegisterStripeVendorCommand();
    command.setParameters(<IRegisterStripeVendorParameters>{
      userId: this._identityService.subUserId,
      code
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  public deleteStripeVendor(appId: number): Observable<boolean> {
    const command = new DeleteStripeVendorCommand();
    command.setParameters(<IDeleteStripeVendorParameters>{
      userId: this._identityService.subUserId,
      appId
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }
}
